<script>
export let detail
export let isTextOpen
export let iconPath
</script>

<div bind:this={detail} class={`fixed bottom-[162px] ${ isTextOpen ? 'textOpen' : 'textClose'}`}>
  <div class="flex items-center justify-start">
    <img src="{iconPath}" alt="ファンアイコン" class="w-5 h-5 rounded-full" />
    <h2 class="ml-2 text-xs text-white text-opacity-80">
      <slot name="name" />からのリクエスト
    </h2>
  </div>
  <p class="mt-3 text-sm font-bold text-white">
    <slot name="detail" />
  </p>
</div>

<style>
.textOpen {
  visibility: visible;
  opacity: 1;
  padding-top: 16px;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  transition:
    visibility 1s ease-out,
    opacity .3s ease-out,
    padding-top .3s ease-out,
    padding-bottom .3s ease-out;
}
.textClose {
  visibility: hidden;
  opacity: 0;
  padding-top: 0;
  padding-right: 24px;
  padding-bottom: 0;
  padding-left: 24px;
  transition:
    visibility 1s ease-out,
    opacity .3s ease-out,
    padding-top .3s ease-out,
    padding-bottom .3s ease-out;
}
</style>
